import createEventHandler from './eventHandler.js';


export default function mediaQuery(queryString) {
    const eventHandler = createEventHandler();
    const mql = window.matchMedia(queryString);


    mql.addEventListener('change', matchMediaHandler);


    // PRIVATE
    function matchMediaHandler() {
        eventHandler.trigger('mediaQueryChange', mql.matches);
        eventHandler.trigger(mql.matches ? 'mediaQueryTrue' : 'mediaQueryFalse');
    }


    // PUBLIC
    function change() {
        matchMediaHandler();
    }

    function onChange(handler) {
        eventHandler.on('mediaQueryChange', handler);
    }

    function onTrue(handler) {
        eventHandler.on('mediaQueryTrue', handler);
    }

    function onFalse(handler) {
        eventHandler.on('mediaQueryFalse', handler);
    }

    function isTrue() {
        return mql.matches;
    }

    function destroy() {
        mql.removeEventListener('change', matchMediaHandler);
    }


    return {
        isTrue,
        onChange,
        change,
        onTrue,
        onFalse,
        destroy
    };
}



// WEBPACK FOOTER //
// ./_src/common/js/mediaQuery.js